import classNames from 'classnames';
import React from 'react';

import css from './IconFlower.module.css';

const IconFlower = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
    >
      <path
        d="M13 29h22v4H13zM32 37l-2 6H18l-2-6"
        fill="none"
        stroke="#011602"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2px"
      />
      <path
        d="M24 5a3.42 3.42 0 0 0-2 3 3.42 3.42 0 0 0 2 3 3.42 3.42 0 0 0 2-3 3.42 3.42 0 0 0-2-3ZM17.636 7.636a3.42 3.42 0 0 0 .707 3.536 3.42 3.42 0 0 0 3.536.707 3.42 3.42 0 0 0-.707-3.536 3.42 3.42 0 0 0-3.536-.707ZM15 14a3.42 3.42 0 0 0 3 2 3.42 3.42 0 0 0 3-2 3.42 3.42 0 0 0-3-2 3.42 3.42 0 0 0-3 2ZM17.636 20.364a3.25 3.25 0 0 0 4.243-4.243 3.25 3.25 0 0 0-4.243 4.243ZM24 23a3.42 3.42 0 0 0 2-3 3.42 3.42 0 0 0-2-3 3.42 3.42 0 0 0-2 3 3.42 3.42 0 0 0 2 3ZM30.364 20.364a3.25 3.25 0 0 0-4.243-4.243 3.25 3.25 0 0 0 4.243 4.243Z"
        fill="none"
        stroke="#011602"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8663027453844734px"
      />
      <path
        d="M33 14a3.25 3.25 0 0 0-6 0 3.25 3.25 0 0 0 6 0ZM30.364 7.636a3.42 3.42 0 0 0-3.536.707 3.42 3.42 0 0 0-.707 3.536 3.42 3.42 0 0 0 3.536-.707 3.42 3.42 0 0 0 .707-3.536Z"
        fill="none"
        stroke="#011602"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8663027453844734px"
      />
      <path
        d="M14.184 20.56A5.07 5.07 0 0 0 12 22.937a4.946 4.946 0 0 0 7.073 2.36M33.826 20.566A5.072 5.072 0 0 1 36 22.937a4.946 4.946 0 0 1-7.073 2.36M24 26v3"
        fill="none"
        stroke="#011602"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2px"
      />
    </svg>
  );
};

export default IconFlower;
